module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("O")]), _vm._v("ne")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("Y")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OU LOOK "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("FANTASTIC!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lissa Roman narrowed her eyes as she studied her reflection in the large, lightbulb-surrounded makeup mirror. She saw perfection and so she should, considering she worked like a long-haul truck driver to look as good as she did. And it wasn’t easy. It took real dedication and nonstop action. Yoga, Pilates, starvation, ice-cold showers, Brazilian waxing, hair coloring, jogging, swimming, weight training, fasting, aerobics, spinning—you name it, Lissa did it. Everything except plastic surgery. She was too scared of the knife. Too petrified that the surgeon would make her look like somebody else—take away her identity, her personality. She had seen it happen to numerous people in Hollywood—women "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("and")]), _vm._v(" men. Besides, she was only forty—younger than Madonna and Sharon Stone, for God’s sake. And anyway, she didn’t need it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("“You’re "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("sure")]), _vm._v(" I look as good as it gets?” she questioned, forcing Fabio, her faithful makeup and hair artist, to repeat his compliments.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Divine. Beautiful. The works,” Fabio assured her, tossing back his luxuriant mane of expensive hair extensions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And he meant every word of it, because although Lissa Roman was not a classic beauty, she had that indiscernible something that made her a superstar. It was a combination of blatant sex appeal, fiery energy, and a body to die for. Not to mention blazing blue eyes, high cheekbones, and full, pouty lips. Fabio "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("loved")]), _vm._v(" basking in her aura.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All thanks to you and your magic fingers,” Lissa murmured, smoothing her shoulder-length platinum hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s what Teddy told me last night,” Fabio said with a self-satisfied smirk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lucky you,” Lissa said, rising from the makeup chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Fabio said, wagging a beringed finger at her. “Lucky "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Teddy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have some ego!” Lissa teased, heading for the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Almost")]), _vm._v(" as big as yours,” Fabio retorted crisply, following her out to the studio, where the photographer from "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Maxim")]), _vm._v(" magazine waited.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lissa and Fabio had worked together for eight years and enjoyed an excellent relationship. Fabio actually "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("liked")]), _vm._v(" Lissa Roman. For someone of her stature, she was not an egocentric bitch. She was warm and friendly and quite funny at times. Of course, she had appalling taste in men—but in Hollywood there was hardly a vast pool of eligible men to choose from. And as far as Fabio was concerned, all the good ones were gay—thank "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("God!")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Her second husband, Antonio—the man who’d fathered her only child—sounded the best of all. Not that Fabio had ever met him, but he’d seen photos, and Antonio was a magnificent specimen—all dark, sexy eyes, impressive physique, and broodingly handsome features. Fabio often wondered why she’d let that one slip away.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Antonio had a wandering cock,” was Lissa’s only explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fabio didn’t get why straight people were so uptight about sex. After all, sometimes a wandering cock could be a good thing.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICCI")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TONE")]), _vm._v(" gazed unblinkingly at her kickboxing instructor’s crotch. It was quite a package, and so was he. His name was Bjorn, and he was tall and blond in the Nordic style, with subtle muscles and sinewy, bronzed thighs. He was over six feet tall, with large Chiclet teeth and a gleaming smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("I bet he gives great tongue,")]), _vm._v(" Nicci thought with a secretive smile. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("He’s Scandinavian. Scandinavian men rock.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not that she’d had that many. Sven, the Swedish facialist. Marl, the Danish rock ’n’ roller. And Lusti, the Norwegian personal trainer. Actually, that was a lot. Enough to make her realize that European men were far more inventive in bed than their American counterparts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She wondered how Bjorn, with his quite commendable package, would stack up. Maybe she should give him a try . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("No!")]), _vm._v(" a stern voice in the back of her head commanded. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("You are currently engaged, and there will be no more screwing around.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Damn! Who came up with "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("that")]), _vm._v(" rule?")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mommy, of course. Lissa Roman—mega movie star, singer, and legendary sex symbol—currently on her fourth husband.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Yeah. That’s right. Four.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci hoped it was Lissa’s lucky number. The next wedding was "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("hers,")]), _vm._v(" and she did not take kindly to competition, even though she had lived with it forever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Growing up with Lissa Roman as your mother was no day trip to Disneyland. Whenever possible, Nicci had kept the identity of her famous mom a deep, dark secret. Although keeping it to herself never lasted long, because somebody always managed to find out—blowing her chance of a normal "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("(What’s that anyway?)")]), _vm._v(" relationship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci was, at nineteen, a spirited kind of beauty. Instead of her mother’s platinum-blond sexiness, Nicci had inherited exotic Gypsy looks from Antonio Miguel Stone, her Spanish father—Lissa’s husband number two—a drop-dead handsome philanderer with no money to speak of and a somewhat shaky pedigree. His mother, Nicci’s grandma, was supposedly a third cousin to the King of Spain—although they’d never been invited to tea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci knew the story. Lissa had fallen for Antonio when he’d arrived in Hollywood to liaise with a gorgeous redhead. Five days after their first meeting, the redhead was history, and Lissa and Antonio were on their way to Vegas in a chartered plane, where after two days of gambling and incredible sex, they’d gotten married.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nine months after that, Nicci was born.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("One passion-filled year later, Lissa caught Antonio cheating with her so-called best friend and promptly divorced him. Shortly after that he’d returned to Europe to continue his career as an ace playboy and sometime ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("race-car driver, roaming around the best resorts and the most beautiful women.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At age ten, Nicci had started demanding to know more about her father—a man she had only seen pictures of. Reluctantly, Lissa had instructed her lawyer to contact her ex and remind him that he had a daughter. Surprisingly, over the next few summers, Antonio had rallied and sent for the little girl. Nicci’s visits were a big success. She was pretty, sassy, and smart, and Antonio was quite entranced. So much so, that over the following years she began spending months at a time with her charismatic dad, until at age fifteen she dropped out of Beverly Hills High School and enrolled at the American school in Madrid. Lissa didn’t seem to mind. Lissa had a career to take care of.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci was thrilled, freedom at last! She soon discovered that Antonio was far more exciting to live with than her mom. He acted more like an older brother than a father figure, full of devilish doings. He taught her what he considered to be all the good things in life—such as how to smoke pot, drink martinis without getting too wasted, and how to handle men with the right combination of flattery and disinterest. One of his many exotic girlfriends had given her a crash course in birth control. How cool was "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("that?")]), _vm._v(" What more could a young, eager-to-learn teenager ask for?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time Nicci was sixteen she was wise way beyond her years, certainly wise enough to realize that her father was incorrigible—a bad boy with a fun-loving disposition and a big heart. He adored his daughter, she was his one link to normality. And Nicci adored him back, even though she knew he was a rogue and somewhat spineless. So what? He was her dad and she loved him.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("The only downside to living with Antonio was his mother, Adela, a fierce-faced woman who dressed only in black and screamed at her son whenever the opportunity arose. Antonio didn’t seem to mind, he gave as good as he got, raising his voice back with no concern about anyone listening. Nicci soon realized it was a game between the two of them. A competition. Their deal was who could scream the longest and loudest. Grandma always won. Grandma was a determined woman. She was also the keeper of the family money, and much to Antonio’s annoyance, she doled it out on "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("her")]), _vm._v(" terms.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Adela owned the house they inhabited in Madrid, plus a luxurious villa in Marbella, both properties left to her by her late husband, who’d suffered a fatal heart attack when Antonio was only ten. Since that time, Adela had drummed it into her handsome son that he was now the man in the family, and therefore, had to look after her. Then she’d promptly sent him off to a military academy, where he’d had the crap beaten out of him on a regular basis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Antonio had finally gotten out, he was ready to party, and in spite of Adela’s objections, party he did, winging his way across Europe and bedding a constant procession of sleek women. Along the way he’d become interested in racing cars. As soon as Adela found out, she’d thrown a fit. To appease her, Antonio made it a hobby instead of a career, a move he’d always regretted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now he split his time between his mother’s two residences, carefully planning to be wherever she wasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Adela was no pushover—she kept tabs on her son. She considered it bad enough that he’d married a cheap, American movie star when he’d ventured out of her range, and she certainly had no intention of allowing that kind of madness to happen again.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Nicci had a strained relationship with her strict grandmother. Adela professed to care for her half-American granddaughter, but at the same time she was forever disapproving of Nicci’s behavior. Nicci soon learned how to deal with her—whenever the criticism and muttering got too much to take, she flew back to L.A. and hardworking Lissa, who was so caught up in her career that she didn’t seem to mind "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("what")]), _vm._v(" Nicci did.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("And Nicci did plenty, for she had inherited both her mother’s passion for breaking rules and her father’s wild ways. She was into experimenting, seeing how far she could go without actually doing “IT.” In spite of her lessons in birth control, she was nervous about going all the way, that is until back in Europe she met Carlos, Antonio’s distant cousin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was seventeen and ready for the big deal. Carlos was twenty-five, self-assured and extremely good looking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It didn’t take him long to break down her inhibitions, then, shortly after, break her heart. Unfortunately, like his cousin, Carlos was a serial philanderer who could not resist a pretty face. Furious and hurt by his rejection, Nicci had traveled the revenge route, jumping into bed with as many men as possible, while harboring the vain hope that Carlos would become hopelessly jealous and beg her to come back to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a great deal of prompting from his mother, Antonio eventually got on her case, pointing out that if she wasn’t careful, people would start calling her a slut and a whore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what are "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("you?”")]), _vm._v(" she’d yelled at her father—a man who found it impossible to keep it in his pants. “A goddamn "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("virgin?”")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("“No. I am a man,” he’d replied with a small superior smile. “And men can do anything.”")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They’d argued bitterly for most of the night, both of them saying things they would grow to regret.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The next morning Nicci had gotten on a plane to L.A. and had not been back to Europe since.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That had been almost two years ago, and now she was engaged and couldn’t help wondering if she should call Antonio and tell him. “Hi, Daddy,” she’d say sweetly. “I’m no longer a slut and a whore. Will you come to my wedding and give me away?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Double Standard. He should’ve called her, and he never had. Oh well, Lissa had always claimed Antonio was a big disappointment, perhaps she was right.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nevertheless, Nicci still loved him, although she certainly did not respect him, for his casual way with women had colored her view of all men, forcing her to adopt the motto: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Use them before they use you.")]), _vm._v(" Up until now she’d run her life that way, unlike dear old Mom, who kept falling in love—or lust, depending on how one looked at it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci admired the professionalism and achievements of her mother. However, she did not feel particularly close to her. How could she when Lissa always seemed to put her career first, love life second, and trailing a poor third, came Nicci, her only child, to whom she’d given birth when she was twenty and on the brink of becoming very famous indeed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci often considered it a good thing that Lissa had not had more children, she was hardly mother material.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No, Lissa Roman was a true superstar, destined to be worshiped by millions.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISSA")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMAN")]), _vm._v(" worked a camera like nobody else. She had all her moves down and enjoyed making love to the lens. Creating dynamic photographs was one of her strengths, and the camera adored her.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Hard work had never bothered Lissa. In fact, hard work was the way her parents—a strict, midwestern couple—had raised her. “Work hard and don’t expect no thanks,” her father, an austere man incapable of giving affection, had drilled into her. So she’d worked her brains out at school, achieving top grades and getting no words of praise from her distant parents. Even when she was voted top of her class, they’d refused to acknowledge that she’d achieved anything. Finally, at sixteen, after a horrible fight with her parents, she’d run away to New York with her high school boyfriend and never gone back. As far as she knew, they’d never come looking, and she didn’t give a damn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you need anything, honey-child?” Fabio asked, standing on the sidelines sipping green tea from a leopard-print mug.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Put on the Nelly Furtado CD,” she requested. “Track four—‘Legend.’ I can’t get enough of that song.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She always made sure to bring a selection of favorite CDs to every session. Today it was Nelly, Sade, and Marc Anthony. She was very into soul and Latin sounds and was currently planning her own CD, which would incorporate plenty of both. She was also working on a book, sitting with a ghost writer whenever she had the time, working to produce a glossy coffee-table book to be titled "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("A Week in the Life of Lissa.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like Madonna and Cher, she was known by one name.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Apart from the CD and the book, there was also a movie she might do—a remake of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Gentlemen Prefer Blondes.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Nothing signed yet; she was waiting for the right script. And in her immediate future was a one-night stand in Vegas at the opening of an incredibly lavish new hotel, the Desert Millennium Princess, which would pay her three million dollars for the pleasure of her company. Quite an achievement. And then there was her daughter’s upcoming wedding, which Nicci had assured her she could deal with herself.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("So Lissa was extremely busy, but not too busy to contemplate her fourth divorce. Currently she was married to Gregg Lynch, a singer/songwriter, ten years younger than her. And thank God her lawyer had insisted that he sign an ironclad prenuptial agreement, because lately she’d begun to suspect that Gregg was composing his love songs elsewhere. And not only that, but over the last six months he’d started showering her with mental abuse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His constant nagging about things she supposedly did wrong was beginning to get her down. There were times he would pick on the smallest detail and yell at her endlessly. Other times he would berate her for not recording "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("his")]), _vm._v(" songs—accusing her manager and agent of mounting a vendetta against him. He’d tried to persuade her to fire them both. “Can’t you see that they’re stealing from you?” he’d yell. “And you’re too dumb and stupid to notice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He distrusted her business manager. Loathed her lawyer. Hated her yoga teacher. Criticized her friends. In fact, anyone who worked for or befriended her was on his shit list.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("She ignored his insults because she knew that deep down he didn’t mean it. And whenever he indulged in one of his temper tantrums, he always apologized later. She also understood "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("why")]), _vm._v(" he was so supercritical. He ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("was furious that he’d never made it, and because of that, he was forced to take his frustration and anger out on "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("someone,")]), _vm._v(" and since she was the closest person to him, that someone was her.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The big problem was that she was never quite sure who she was going to wake up next to—the good or the bad Gregg. Unfortunately, they now seemed to exist side by side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She couldn’t stand him when he was in one of his bad moods. Loved him when he was mellow and caring and supportive—qualities that were fast vanishing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lissa was prepared to put up with a lot, but she was no Hillary Clinton. She knew from past experience there was no such animal as the perfect man; the one thing she refused to stand for was infidelity. The moment she suspected that might be happening, it was time to move on, and lately she’d been recognizing the signs only too well: all-night meetings, a renewed interest in his personal appearance, taking one shower a day too many, and developing a paranoid attachment to his cell phone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as Gregg started exhibiting the symptoms, she’d called the Robbins/Scorsinni Private Investigation Agency and requested a forty-eight-hour surveillance. She’d used the agency on other occasions and they’d never failed her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was so depressing that it had to come to this again. Why was it that she had yet to marry a man who could keep it in his pants?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nelly Furtado crooned over the sound system. Lissa licked her already glossy lips while Fabio fussed with her hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Will we be finished soon?” she asked Max, her publicist, who was hovering on the sidelines with a group of people from the magazine.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("“Anytime you want,” said Max, a short, cigar-smoking man who wore flamboyant suits and had a different bow tie for every day of the month.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“One more roll,” the photographer begged. He was young, in awe, and excellent at what he did.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lissa was always open to young and excellent, it kept her career edgy and fresh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throwing her head back, she struck a pose, honoring the camera with a true-to-form provocative gaze. Parted lips, half-closed diamond-blue eyes, an expression of sexual yearning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lissa Roman gave great sex. It always paid off.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICKBOXING CLASS OVER")]), _vm._v("—a virtual feast of kicking, punching, and sparring—Nicci hurried into the dressing room, took a quick shower and changed into shorts and a stomach-baring T-shirt, all the better to show off her killer abs, glowing tan, and recent navel piercing. Then she stared in the mirror for a moment, which reminded her that she’d certainly inherited Antonio’s looks. Rich, dark brown hair cropped like a gamine, with long bangs falling into her huge brown eyes, which were fringed with impossibly long, silky, midnight-black lashes. Long legs and a lithe, lean body. Her overly full, sexy lips and high cheekbones were the only clue that she was Lissa Roman’s daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes, she decided, she was definitely going to call Antonio. He "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("had")]), _vm._v(" to come to her wedding. He was her father, after all, and she needed him beside her on the most important day of her life. It wasn’t like she had any other family—Lissa’s parents were forbidden territory, although Nicci had always harbored a secret desire to contact them, see if they were as strict and unloving as Lissa said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Grabbing her bag, she headed for the car park, where she climbed behind the wheel of her gleaming silver sports BMW, an engagement present from her fiancé, Evan.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Ah . . . Evan, she thought fondly. A goer. A doer. A man with a mission. Thirty years old and already a self-made millionaire thanks to a string of offbeat comedy movies he’d cowritten and coproduced with his brother, Brian.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So intently was Nicci thinking about Evan, that she did not notice the dusty brown van pull away from the curb and fall in behind her car as she left the parking lot and hit Sunset.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Evan and Brian Richter. A younger, hipper version of the Farrelly brothers. Their rise to power had been meteoric—six movies in five years, all of them box-office smashes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci had met Evan at the dog park on the top of Mulholland. She’d been walking her then-current boyfriend’s Great Dane, and Evan had been trying to control a couple of crazed, large German shepherd puppies that were intent on running riot and attacking as many other dogs as possible. Coolly assessing the situation, she’d gone up to him, grabbed the dog leashes out of his helpless hand, chased down both puppies, and gotten them firmly collared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here,” she’d said brusquely, delivering the two German shepherds back to Evan. “I suggest you hire a trainer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How much?” he’d asked, all spiky brown hair, lanky limbs, and comic-book features.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How much what?” she’d answered haughtily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How much’ll "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("you")]), _vm._v(" charge to do it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A disdainful look. “You can’t afford me.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("A crooked grin. “Wanna bet?”")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("What the hell . . . she had no job to speak of, and he seemed vaguely legitimate. “A thousand a week. Cash,” she’d said, challenging him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No challenge was too big for Evan Richter. “When can you start?” he’d said, admiring her spunky attitude.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And that’s how it all began. A casual meeting, with neither of them knowing anything about the other. He’d only kept the dogs a few weeks, because they were messing up his impeccable house, but by that time Nicci and he were quite inseparable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That had been five months ago and now they were due to be married in six weeks and she had a wedding to organize with no help from Lissa, whose only suggestion had been to hire a wedding planner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci sighed. Naturally, she loved Evan. Sort of. Well, he made her laugh, didn’t treat her badly, and gave great head. He could also handle the fact that she had a famous mom—which freaked out most guys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That should be enough to sustain a long and fruitful marriage . . . shouldn’t it?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes. Except there was one tiny, little drawback. Very small. Extremely insignificant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci loved Evan’s brother too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And sometimes she wasn’t sure which one of the Richter brothers she loved more.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 75
// module chunks = 0